import { useEffect, forwardRef } from "react";
import Warranty from "./modals/Warranty";
interface Props {
  onSuccess?: () => void;
  loanApplicationId?: string;
  isEdit: boolean;
}

const WarrantyForm = forwardRef(({ onSuccess, loanApplicationId, isEdit }: Props, ref) => {

  useEffect(() => {
    if (ref) {
      // @ts-ignore
      ref.current = {
        submitForm: () => {
          onSuccess?.();
        },
      };
    }
  }, [ref, onSuccess]);

  return (
    <div>
      <Warranty loanApplicationId={loanApplicationId} />
    </div>
  );
});

export default WarrantyForm;
